import { useMutation } from "react-query"
import { APIEndpoints } from "../constants/api-endpoints"
import { HttpRequest } from "../services/_http"

interface BulkLabelGenerationRequest {
  episode_ids: string[]
  prompt?: string
}

interface BulkLabelGenerationResponse {
  results: Array<{
    episode_id: string
    episode_name: string
    status: 'success' | 'failed'
    labels?: string[]
    content_source?: string
    error_message?: string
    processing_time: number
    processed_at: string
  }>
  total_episodes: number
  successful_episodes: number
  failed_episodes: number
  message: string
}

export const useBulkLabelGeneration = () => {
  return useMutation((request: BulkLabelGenerationRequest) => {
    return HttpRequest({
      url: '/label-gen/bulk-generate',
      method: 'POST',
      data: request,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  })
}

interface BulkCategoryLabelGenerationRequest {
  category_ids: string[]
  prompt?: string
}

interface BulkShowLabelGenerationRequest {
  show_ids: string[]
  prompt?: string
}

interface BulkCollectionLabelGenerationRequest {
  collection_ids: string[]
  prompt?: string
}

export const useBulkCategoryLabelGeneration = () => {
  return useMutation((request: BulkCategoryLabelGenerationRequest) => {
    return HttpRequest({
      url: '/label-gen/bulk-generate-categories',
      method: 'POST',
      data: request,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  })
}

export const useBulkShowLabelGeneration = () => {
  return useMutation((request: BulkShowLabelGenerationRequest) => {
    return HttpRequest({
      url: '/label-gen/bulk-generate-shows',
      method: 'POST',
      data: request,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  })
}

export const useBulkCollectionLabelGeneration = () => {
  return useMutation((request: BulkCollectionLabelGenerationRequest) => {
    return HttpRequest({
      url: '/label-gen/bulk-generate-collections',
      method: 'POST',
      data: request,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  })
}
